import { render, staticRenderFns } from "./PHQ9.vue?vue&type=template&id=19962ce0&scoped=true&"
import script from "./PHQ9.vue?vue&type=script&lang=js&"
export * from "./PHQ9.vue?vue&type=script&lang=js&"
import style0 from "./PHQ9.vue?vue&type=style&index=0&id=19962ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19962ce0",
  null
  
)

export default component.exports